import { AfterViewInit, ContentChild, OnChanges, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, } from '@angular/core';
import { FilterBadgeModel } from '../filter.model';


@Component({
  selector: 'q-badge-filter',
  templateUrl: './badge-filter.component.html',
  styleUrls: ['./badge-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class BadgeFilterComponent implements AfterViewInit, OnChanges {

  constructor(
    private ChangeDetector: ChangeDetectorRef,
  ) { }

  @Output('FilterBadgeChange') FilterBadgeChange: EventEmitter<Array<FilterBadgeModel>> = new EventEmitter<Array<FilterBadgeModel>>();
  @Input('FilterBadge') filterBadge = new Array<FilterBadgeModel>();
 /* set FilterBadge(value: Array<FilterBadgeModel>) {
    if (value) {
      this.ListFilter = value;
      this.ComputBadgeSize();
    }
  }*/

  @ViewChild('BadgeWrapper') BadgeWrapper: ElementRef;
  @ViewChild('ClearAllBtn') ClearAllBtn: ElementRef;
  @ViewChild('BadgeExpendBtn') BadgeExpendBtn: ElementRef;

  public BadgeSliceEnd: number = 0;
  public BadgeExpendNumber: number = 0;
  public ListFilter: Array<FilterBadgeModel> = new Array<FilterBadgeModel>();
  public ListFilterWithoutHiddenBadge: Array<FilterBadgeModel> = new Array<FilterBadgeModel>();
  public BadgeExpended: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.ComputBadgeSize();
  }

  public ComputBadgeSize() {
    this.ChangeDetector.detach();

    this.ListFilterWithoutHiddenBadge = this.ListFilter.filter((badge: FilterBadgeModel) => !badge.Hidden);

    this.BadgeSliceEnd = this.ListFilterWithoutHiddenBadge.length;

    this.BadgeExpendNumber = 0;
    let elementCount: number = 0;
    let elementWidth: number = 0;

    this.ListFilterWithoutHiddenBadge.every((badge: FilterBadgeModel) => {
      
      //Creation de badge factice pour calculer leurs largeurs
      let filterBadge = document.createElement("div");
      filterBadge.classList.add('q-filter-badge-computed');
      filterBadge.innerHTML = `<div class="q-filter-badge-value-computed"><strong>${badge.Text}:</strong>${badge.Value}</div><button class="q-filter-badge-button-computed"><i class="fas fa-times"></i></button>`;
      filterBadge.style.visibility = 'hidden';
      document.body.append(filterBadge)

      // les +5 dans les calcules sont les margins rigth qui ne sont pas prise en compte dans le getclientrects et c'est overkill de faire un getcomputedstyle pour recup une valeur qui ne va pas changer 
      let badgeWidth: number = filterBadge.getClientRects()[0].width + 5;

      filterBadge.remove();

      //Recuperation du nombre de badge max que l'on peut afficher sur une ligne 
      if (elementWidth + badgeWidth +
        (this.BadgeExpendBtn ? this.BadgeExpendBtn.nativeElement.getClientRects()[0].width + 5 : 32) +
        (this.ClearAllBtn ? this.ClearAllBtn.nativeElement.getClientRects()[0].width : this.ListFilterWithoutHiddenBadge.length > 1 ? 82 : 0)
        > this.BadgeWrapper.nativeElement.clientWidth) {

        if (!this.BadgeExpended) {
          this.BadgeSliceEnd = elementCount;
        }
        return false;
      }
      elementWidth += badgeWidth; 

      elementCount++;
      return true;
    });

    this.BadgeExpendNumber = this.ListFilterWithoutHiddenBadge.length - elementCount;
    if (this.BadgeExpendNumber == 0) {
      this.BadgeExpended = false;
    }

    this.ChangeDetector.detectChanges();
  }

  public BadgeExpend() {
    this.BadgeExpended = !this.BadgeExpended;
    if (this.BadgeExpended) {
      this.BadgeExpendNumber = 0;
      this.BadgeSliceEnd = this.ListFilterWithoutHiddenBadge.length;
      this.ChangeDetector.detectChanges();
    } else {
      this.ComputBadgeSize();
    }
  }

  public RazFilter(filterBadge: FilterBadgeModel|null) {
    if (filterBadge) {
      let index = this.ListFilter.findIndex(x => x.PropKey == filterBadge.PropKey && x.PropValue == filterBadge.PropValue);
      if (index >= 0) {
        this.ListFilter.splice(index, 1);
        this.FilterBadgeChange.emit([...this.ListFilter]);
        this.ComputBadgeSize();
      }
    } else {
      this.ListFilter = this.ListFilter.filter((badge: FilterBadgeModel) => { return badge.Hidden});
      this.FilterBadgeChange.emit(this.ListFilter);
      this.ComputBadgeSize();
    }
  }

  public ngAfterViewInit() {
    this.ComputBadgeSize();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.filterBadge.firstChange && changes.filterBadge.currentValue) {
      this.ListFilter = changes.filterBadge.currentValue;
      return;
    }

    if (changes.filterBadge.currentValue != changes.filterBadge.previousValue) {
      this.ListFilter = changes.filterBadge.currentValue;
      this.ComputBadgeSize();
    }
  }
}


